module.exports = __webpack_public_path__ + "static/img/body.5623b25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/body.jpg
// module id = 20QJ
// module chunks = 1